import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2020 semantics GmbH
//  Date      : $Date: 2026-05-27 14:18:05 +0200 (Wed, 27 May 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 163319 $
//  Purpose   : test ui-props (parts feature) and usePersistent hook
// =============================================================================
// ---Third-party imports
import React from 'react';
import { Message } from 'semantic-ui-react';
// ---Framework imports
import { funcPart } from 'uix/parts';
import { usePersistent, usePersistentShallow } from 'uix/hooks';
// ---Globals
const buildUiPropsPart = (uiDefaults, onClick, nameOverride = null)=>funcPart(({ type })=>{
        let storeKey = nameOverride || type;
        let [ui, setUI] = usePersistentShallow(storeKey, uiDefaults);
        return /*#__PURE__*/ _jsx(UiPropsMsg, {
            type: type,
            onClick: ()=>onClick(setUI),
            ui: ui
        });
    });
export const TestUIProps = buildUiPropsPart({
    __version__: 6,
    majorValue: 'TestUIProps',
    minorValue: 'empty'
}, (setUI)=>setUI({
        majorValue: Math.random()
    }));
const UiPropsMsg = ({ type, onClick, ui })=>{
    return /*#__PURE__*/ _jsxs(Message, {
        children: [
            'Part ',
            /*#__PURE__*/ _jsx("b", {
                onClick: onClick,
                style: {
                    cursor: 'pointer'
                },
                children: type
            }),
            ' with ',
            /*#__PURE__*/ _jsx("span", {
                className: "value",
                children: JSON.stringify(ui)
            })
        ]
    });
};
export const TestUIPropsDerived1 = buildUiPropsPart({
    __version__: 3,
    minorValue: 'TestUIPropsDerived1'
}, (setUI)=>setUI({
        minorValue: Math.random()
    }));
export const TestUIPropsDerived2 = buildUiPropsPart({
    __version__: 6,
    majorValue: 'TestUIProps',
    minorValue: 'empty'
}, (setUI)=>setUI({
        majorValue: Math.random()
    }));
export const TestUIPropsDerived3 = buildUiPropsPart({
    __version__: 3,
    majorValue: 'TestUIPropsDerived3'
}, (setUI)=>setUI({
        majorValue: Math.random()
    }));
export const TestUIPropsDerived4 = buildUiPropsPart({
    __name__: 'SHARED_NAME',
    sharedValue: 1
}, (setUI)=>setUI({
        sharedValue: `Derived4 - ${Math.random()}`
    }), 'SHARED_NAME');
export const TestUIPropsDerived5 = buildUiPropsPart({
    __name__: 'SHARED_NAME',
    sharedValue: 2
}, (setUI)=>setUI({
        sharedValue: `Derived5 - ${Math.random()}`
    }), 'SHARED_NAME');
export const TestUIPropsFunctional = funcPart(({ type })=>{
    let [ui, setUI] = usePersistentShallow(type, {
        majorValue: 'value0',
        __version__: 1
    });
    return /*#__PURE__*/ _jsx(UiPropsMsg, {
        type: type,
        ui: ui,
        onClick: ()=>setUI({
                majorValue: Math.random()
            })
    });
});
export const TestUIPropsHooks = ()=>{
    let [ui, setUI] = usePersistentShallow('hooktest', {
        majorValue: 'value1',
        stable: 1
    }, 1);
    return /*#__PURE__*/ _jsx(UiPropsMsg, {
        type: "TestUIPropsHooksShallow",
        ui: ui,
        onClick: ()=>setUI({
                majorValue: Math.random()
            })
    });
};
export const TestUIPropsHooksRaw = ()=>{
    let [value, setValue] = usePersistent('hooktest_raw', 'ABC', 1);
    return /*#__PURE__*/ _jsx(UiPropsMsg, {
        type: "TestUIPropsHooksRaw",
        ui: value,
        onClick: ()=>setValue(Math.random())
    });
};
